import React, { useContext } from 'react'
import { ModalContext } from 'providers/Modal'
import modalStyles from 'styles/modal.module.scss'
import clsx from 'clsx'
import { ReactFinalFormContext } from 'react-final-form'

const SwitchTo = ({ styles, trackLoginClickFn }) => {
  const { setActive, setEmail } = useContext(ModalContext)
  const { getFieldState } = useContext(ReactFinalFormContext)
  const switchToLogin = () => switchForm('login')

  const switchForm = formId => {
    setActive(formId)
    setEmail(getFieldState('email').value)
    if (trackLoginClickFn) {
      trackLoginClickFn(getFieldState('email').value)
    }
  }

  return (
    <p className={clsx(modalStyles.switcher, styles)}>
      Already a Member?{' '}
      <a
        data-testid="modal_login"
        href="javascript:void(0)"
        onTouchStart={switchToLogin}
        onMouseDown={switchToLogin}
      >
        Login
      </a>
    </p>
  )
}

export default SwitchTo
